module.exports = __webpack_public_path__ + "img/gallery.a52905e7.png";